<template>
  <div
    class="w-screen h-screen flex flex-column align-items-center overflow-y-scroll"
  >
    <div class="w-full flex justify-content-center surface-900">
      <div
        class="w-full px-3 py-2 flex text-white"
        style="max-width: min(56rem, 100vw)"
      >
        <h1
          @click="$router.push({ name: 'root' })"
          class="font-italic cursor-pointer select-none"
        >
          INIGO SELWOOD
        </h1>
      </div>
    </div>

    <div
      class="w-full p-3 flex-grow-1 flex flex-column gap-3 bg-white"
      style="max-width: min(56rem, 100vw)"
    >
      <router-view />
    </div>
  </div>
</template>

<script>
import Button from 'primevue/button'

export default {
  components: {
    Button,
  },
}
</script>

<style>
* {
  font-family: 'Inter', Arial, sans-serif;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.background {
  background: #eeaeca;
  background: radial-gradient(
    circle,
    rgba(238, 174, 202, 1) 0%,
    rgba(148, 187, 233, 1) 100%
  );
}

.monospace {
  font-family: 'Space Mono', monospace;
}

*::-webkit-scrollbar {
  display: none;
}

p,
h1,
label {
  margin: 0;
}

a {
  text-decoration-line: underline;
  text-decoration-color: black;
  color: black;
  transition: text-decoration-color 0.2s;
  cursor: pointer;
}

a:hover {
  text-decoration-color: transparent;
}

hr {
  width: 100%;
  margin: -0.25rem 0rem;
}

ul {
  margin: -0.25rem 0;
}

div.vr {
  width: 1px;
  height: 100%;
  margin: 0 0.25rem;
  background: black;
}
</style>
